module.exports = __webpack_public_path__ + "assets/img/chatwork.b1442600.png";